const continents = [
  { value: 'Africa', label: 'Africa' },
  { value: 'Asia', label: 'Asia' },
  { value: 'Europe', label: 'Europe' },
  { value: 'North America', label: 'North America' },
  { value: 'South America', label: 'South America' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Antarctica', label: 'Antarctica' }
];

export default continents;